import React, { memo } from 'react';
import { useIntl } from 'umi';

interface ITokenTotalCmpProps {
  value?: number;
}

export const TokenTotalCmp = memo(({ value }: ITokenTotalCmpProps) => {
  const { formatMessage } = useIntl();

  if (!value) {
    return null;
  }

  return (
    <div className="dba-token-total">
      {formatMessage(
        { id: 'dba_agent_token_total_done' },
        { tokens: value },
      )}
    </div>
  );
});

TokenTotalCmp.displayName = 'TokenTotalCmp';
